/*!
 * Nanocoating.nl — Verbruikscalculator in blogartikelen
 * - Rekent met dezelfde verbruikscijfers als de keuzehulp (productpagina's, okt 2026)
 * - Prijzen, flesmaten en voorraad worden live opgehaald via /products/<handle>.js
 * - Kiest de voordeligste combinatie flesmaten en voegt toe via /cart/add.js
 * - Volgt het doel van het artikel: beschermen (coating), reinigen (reiniger) of beide, met de andere kant als optionele aanvulling
 * - Kiest bij een specifiek probleem (kalkuitbloei, cementsluier, graffiti) de bijbehorende verwijderaar
 * Pas je verbruik of producten aan? Doe dat hieronder én in de keuzehulp (keuzehulp.js).
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* 1. Producten — cov = m² per liter per laag; v = terugval [ml, centen] */
  /*    free = vanaf deze hoeveelheid coating 1 liter reiniger gratis      */
  /* ------------------------------------------------------------------ */
  var PRODUCTS = {
    coat_glas: { h: 'nc-nano-coating-voor-glas', n: 'NC Nano Coating voor Glas', cov: 40, v: [[100, 2590], [200, 4662], [300, 6605], [500, 10360]], free: { min: 300, clean: 'clean_glas' } },
    coat_steen: { h: 'nc-nano-coating-voor-steen-beton-tegel', n: 'NC Nano Coating voor Steen, Beton & Tegel', cov: 5, v: [[1000, 2968], [2000, 5342], [3000, 8017], [5000, 11872]], free: { min: 3000, clean: 'clean_steen' } },
    coat_textiel: { h: 'nc-nano-coating-voor-textiel-leder-suede', n: 'NC Nano Coating voor Textiel, Leder & Suède', cov: 4, v: [[1000, 2991], [2000, 5384], [3000, 8076], [5000, 11964]], free: { min: 3000, clean: 'clean_textiel' } },
    coat_hout: { h: 'nano-coating-voor-hout', n: 'NC Nano Coating voor Hout', cov: 8, v: [[1000, 3160], [2000, 5688], [3000, 8058], [5000, 12640]], free: { min: 3000, clean: 'clean_hout' } },
    coat_auto: { h: 'nc-nano-coating-voor-autolak', n: 'NC Nano Coating voor Autolak', cov: 66, v: [[500, 2834], [1000, 5101], [1500, 7226], [2500, 11336]] },
    coat_kunststof: { h: 'nc-nano-coating-voor-kunststof', n: 'NC Nano Coating voor Kunststof', cov: 60, v: [[100, 3478], [200, 6261], [300, 8870], [500, 13914]], free: { min: 300, clean: 'clean_kunststof' } },
    coat_metaal: { h: 'nc-nano-coating-voor-metaal-en-rvs', n: 'NC Nano Coating voor Metaal en RVS', cov: 60, v: [[1000, 2903], [2000, 5225], [3000, 7402], [5000, 11612]], free: { min: 3000, clean: 'ontvetter' } },
    coat_muur: { h: 'nc-nano-coating-voor-muurverf', n: 'NC Nano Coating voor Muurverf', cov: 18, v: [[1000, 2975], [2000, 5354], [3000, 7585], [5000, 11898]], free: { min: 3000, clean: 'ontvetter' } },
    clean_glas: { h: 'nc-glasreiniger', n: 'NC Nano Glasreiniger', cov: 7.5, v: [[1000, 1514], [2000, 2725], [3000, 3861], [5000, 6056]] },
    clean_steen: { h: 'nc-steenreiniger', n: 'NC Nano Steenreiniger', cov: 12, range: '5 tot 15 m² per liter', v: [[1000, 2505], [3000, 6764], [5000, 10020]] },
    clean_hout: { h: 'nc-houtreiniger', n: 'NC Nano Houtreiniger', cov: 7.5, v: [[1000, 2545], [3000, 6874], [5000, 10184]] },
    clean_textiel: { h: 'nc-textielreiniger', n: 'NC Nano Textielreiniger', cov: 10, v: [[1000, 2515], [3000, 6791], [5000, 10060]] },
    clean_kunststof: { h: 'nc-nano-kunststofreiniger', n: 'NC Nano Kunststofreiniger', cov: 7.5, v: [[1000, 1518], [2000, 2733], [3000, 3871], [5000, 6072]] },
    ontvetter: { h: 'nc-nano-ontvetter', n: 'NC Nano Ontvetter', cov: 15, v: [[1000, 1475]] },
    /* Verwijderaars en anti-graffiti: verbruik uit de productpagina's (gemiddelde van het genoemde bereik) */
    clean_kalk: { h: 'nc-nano-kalkuitbloeiverwijderaar', n: 'NC Nano Kalkuitbloeiverwijderaar', cov: 1.5, range: '1 tot 2 m² per liter', v: [[1000, 1458], [2000, 2625], [3000, 3719], [5000, 5834]] },
    clean_cement: { h: 'nc-nano-cementsluierverwijderaar', n: 'NC Nano Cementsluierverwijderaar', cov: 4.5, range: '3 tot 6 m² per liter', v: [[1000, 1449], [2000, 2608], [3000, 3695], [5000, 5797]] },
    clean_graffiti: { h: 'nc-nano-graffitiverwijderaar', n: 'NC Nano Graffitiverwijderaar', cov: 7.5, range: '5 tot 10 m² per liter (poreus) of 5 tot 15 m² per liter (niet-poreus)', v: [[1000, 3591], [2000, 6464], [3000, 9157], [5000, 14365]] },
    coat_graffiti: { h: 'nc-nano-anti-graffiti-coating', n: 'NC Nano Anti Graffiti Coating', cov: 7.5, range: '5 tot 10 m² per liter per laag', v: [[1000, 3984], [2000, 7170], [3000, 10158], [5000, 15934]] },
    shampoo: { h: 'nc-nano-autoshampoo', n: 'NC Nano Autoshampoo', fixed: true, v: [[null, 1648]] }
  };
  var MARGIN = 1.1; // 10% extra marge

  /* ------------------------------------------------------------------ */
  /* 2. Ondergronden                                                      */
  /*    kinds: keuzes die het verbruik bepalen (cov overschrijft product)  */
  /*    m2 bij een keuze = vaste oppervlakte (voertuigen)                  */
  /* ------------------------------------------------------------------ */
  var MATERIALS = {
    steen: { label: 'Steen, beton en tegels', cleanOk: true, ctip: 'Reiniger: laat ongeveer 30 minuten inwerken, schrob en spoel na. Verwerken tussen 5 en 30 °C bij droog weer.', coat: 'coat_steen', clean: 'clean_steen', cleanWhy: 'Verplichte eerste stap: haalt groene aanslag en ingetrokken vuil uit de poriën.',
      kq: 'Wat gebeurt er als je er water op druppelt?',
      kinds: [
        { v: 'zuigend', l: 'Trekt direct in', h: 'Baksteen, beton, oude tegels', cov: 3.5 },
        { v: 'normaal', l: 'Trekt langzaam in', h: 'Betontegels, gezoet natuursteen', cov: 5, def: true },
        { v: 'dicht', l: 'Blijft als druppel liggen', h: 'Gepolijst of eerder behandeld', cov: 6.5, warn: 'Blijft water als druppel liggen? Dan is de steen misschien al behandeld of erg dicht en trekt de coating slecht in. Test eerst op een klein, onopvallend stukje.' }
      ],
      presets: [['Klein terras', 15], ['Gemiddeld terras', 30], ['Oprit', 50], ['Badkamervloer', 6]],
      tip: 'Verwerken tussen 10 en 30 °C op een droge ondergrond. De coating is na 8 uur uitgehard.' },
    hout: { label: 'Hout', cleanOk: true, coat: 'coat_hout', clean: 'clean_hout', cleanWhy: 'Reinigt het hout diep zodat de coating goed intrekt.',
      kq: 'Hoe ziet het hout eruit?',
      kinds: [
        { v: 'kaal', l: 'Kaal of nieuw', h: 'Onbehandeld, ook hardhout of steigerhout', cov: 8 },
        { v: 'grijs', l: 'Vergrijsd of verweerd', h: 'Groen of grijs uitgeslagen', cov: 6, mustClean: 'Bij vergrijsd hout is reinigen nodig om de kleur terug te halen.' },
        { v: 'behandeld', l: 'Gebeitst, gelakt of geverfd', h: 'Er zit een laag op het hout', stop: 'Op gebeitst, gelakt of geverfd hout werkt de houtcoating niet. Schuur het hout kaal als je het wilt beschermen.' }
      ],
      presets: [['Tuinset', 6], ['Vlonder', 20], ['Schutting 10 m, 2 kanten', 36]],
      tip: 'Verdeel over 2 à 3 lagen en laat elke laag goed intrekken. Niet verwerken bij regen of onder 5 °C.' },
    textiel: { label: 'Textiel, leder en suède', cleanOk: true, coat: 'coat_textiel', clean: 'clean_textiel', cleanWhy: 'Haalt vuil en geur uit de vezels. Laat daarna goed drogen.',
      kq: 'Welk materiaal?',
      kinds: [
        { v: 'stof', l: 'Stof', h: 'Katoen, polyester, linnen, canvas', cov: 4 },
        { v: 'leder', l: 'Leder', h: '', cov: 5 },
        { v: 'suede', l: 'Suède of nubuck', h: '', cov: 4 }
      ],
      presets: [['1 jas', 2], ['3-zitsbank', 6], ['Set tuinkussens', 4], ['Zonnescherm 4 × 3 m', 12]],
      tip: 'Breng één verzadigende laag aan en laat 24 uur drogen. Test op leder en suède eerst op een onopvallende plek.' },
    glas: { label: 'Glas, douchewand en spiegels', cleanOk: true, coat: 'coat_glas', clean: 'clean_glas', cleanWhy: 'Verwijdert vet, vuil en kalk, zodat de coating goed hecht.',
      presets: [['Douchewand', 2], ['Douchecabine', 6], ['1 raam, 2 kanten', 3], ['± 10 ramen buitenkant', 15]],
      tip: 'Een dunne laag is genoeg; poets uit tot je niets meer ziet. Na 2 uur waterbestendig.' },
    auto: { label: 'Autolak', coat: 'coat_auto', clean: 'shampoo', cleanWhy: 'Wast de lak grondig en bereidt hem voor op de coating.',
      kq: 'Welk voertuig?',
      kinds: [
        { v: 'klein', l: 'Kleine auto', h: '± 8 m² lak', m2: 8 },
        { v: 'middel', l: 'Gemiddelde auto', h: '± 11 m² lak', m2: 11 },
        { v: 'groot', l: 'SUV of bestelbus', h: '± 15 m² lak', m2: 15 },
        { v: 'motor', l: 'Motor', h: '± 3 m²', m2: 3 },
        { v: 'camper', l: 'Camper of caravan', h: '± 40 m²', m2: 40 }
      ],
      tip: 'Werk in de schaduw op koele lak, tussen 5 en 30 °C. Na ± 6 maanden opnieuw aanbrengen.' },
    kunststof: { label: 'Kunststof', cleanOk: true, coat: 'coat_kunststof', clean: 'clean_kunststof', cleanWhy: 'Maakt verweerd kunststof diep schoon, zodat de coating goed hecht.',
      presets: [['Paar kozijnen', 4], ['Kozijnen rijtjeshuis', 15], ['Gevelbekleding', 30]],
      tip: 'Laat 1 minuut intrekken, veeg het overtollige weg en poets uit.' },
    metaal: { label: 'Metaal en RVS', coat: 'coat_metaal', clean: 'ontvetter', cleanWhy: 'Maakt het metaal vet- en vuilvrij, nodig voor een goede hechting.',
      presets: [['Kraan en douchestang', 1], ['RVS keukenblad', 3]],
      tip: 'Laat goed uitharden voordat het nat wordt.' },
    muur: { label: 'Geschilderde binnenmuur', coat: 'coat_muur', clean: 'ontvetter', cleanWhy: 'Ontvet de bestaande muurverf zodat de coating goed hecht.',
      kq: 'Hoe intensief wordt de muur gebruikt?',
      kinds: [
        { v: 'normaal', l: 'Normaal', h: 'Woonkamer, slaapkamer', layers: 1 },
        { v: 'druk', l: 'Intensief', h: 'Hal, kinderkamer, keuken', layers: 2 }
      ],
      presets: [['1 wand', 10], ['Hal', 25], ['Woonkamer', 45]],
      tip: 'Werk nat-in-nat en rol alle banen in dezelfde richting na. Test eerst op een onopvallende plek.' }
  };
  /* Probleem-scenario's: een specifieke verwijderaar uit de winkel (verbruik en gebruik volgens de productpagina's).
     kinds/kq = keuzes voor de coating (cross-sell), ckinds/ckq = keuzes voor de reiniger (ccov = m² per liter) */
  MATERIALS.kalk = { problem: true, cleanOk: true, label: 'Kalkuitbloei op muur of gevel', coat: 'coat_steen', clean: 'clean_kalk',
    kq: MATERIALS.steen.kq, kinds: MATERIALS.steen.kinds,
    ckq: 'Hoe hardnekkig is de uitbloei?',
    ckinds: [
      { v: 'licht', l: 'Licht', h: 'Net begonnen, dun wit laagje', ccov: 2 },
      { v: 'gemiddeld', l: 'Gemiddeld', h: 'Duidelijk zichtbaar', ccov: 1.5, def: true },
      { v: 'zwaar', l: 'Hardnekkig', h: 'Dikke, hardnekkige laag', ccov: 1 }
    ],
    cwarn: 'Niet geschikt voor zuurgevoelige ondergronden zoals kalkhoudend natuursteen, beton en kunststof. Het product is bedoeld voor baksteen en cementgebonden voegmortel.',
    presets: [['Stuk muur', 5], ['Gevelpui', 15], ['Voorgevel', 40]],
    ctip: 'Reiniger: onverdund aanbrengen met kwast of bezem, laten inwerken en herhalen tot het niet meer bruist. Spoel af met hogedruk (50 tot 80 bar). Verwerken tussen 5 en 30 °C bij droog weer.',
    tip: MATERIALS.steen.tip };
  MATERIALS.cement = { problem: true, cleanOk: true, label: 'Cementsluier op tegels of steen', coat: 'coat_steen', clean: 'clean_cement',
    kq: MATERIALS.steen.kq, kinds: MATERIALS.steen.kinds,
    ckq: 'Hoeveel cementsluier zit erop?',
    ckinds: [
      { v: 'licht', l: 'Dun laagje', h: 'Lichte sluier', ccov: 6 },
      { v: 'gemiddeld', l: 'Gemiddeld', h: 'Duidelijk zichtbaar', ccov: 4.5, def: true },
      { v: 'zwaar', l: 'Hardnekkig', h: 'Dikke cement- of kalkresten', ccov: 3 }
    ],
    cwarn: 'Dit product is zuur (pH ca. 1) en bedoeld voor zuurbestendige ondergronden, zoals geglazuurde tegels en glas. Niet verdunnen of mengen met andere producten.',
    presets: [['Badkamervloer', 6], ['Keuken en gang', 15], ['Terras', 20]],
    ctip: 'Reiniger: onverdund aanbrengen, 5 tot 10 minuten laten inwerken, schrobben en grondig naspoelen. Binnen goed ventileren. Verwerken tussen 5 en 30 °C.',
    tip: MATERIALS.steen.tip };
  MATERIALS.graffiti = { problem: true, cleanOk: true, label: 'Graffiti op muur of gevel', coat: 'coat_graffiti', clean: 'clean_graffiti',
    kq: 'Hoeveel lagen anti-graffiti coating?',
    kinds: [
      { v: 'l2', l: '2 lagen', h: 'Minimum volgens de gebruiksaanwijzing', layers: 2 },
      { v: 'l3', l: '3 lagen', h: 'Volgens de specificaties voor de langste levensduur', layers: 3, def: true }
    ],
    ckq: 'Wat voor ondergrond is het?',
    ckinds: [
      { v: 'poreus', l: 'Poreus', h: 'Steen, beton, metselwerk, natuursteen', ccov: 7.5, def: true },
      { v: 'dicht', l: 'Niet-poreus', h: 'Metaal, glas, geglazuurde tegels', ccov: 10 }
    ],
    coatNote: 'Op poreuze ondergrond adviseert de productpagina van de verwijderaar om direct daarna anti-graffiti coating aan te brengen.',
    presets: [['Kleine tag', 1], ['Muurvlak', 10], ['Gevel', 30]],
    ctip: 'Reiniger: op poreuze ondergrond 20 tot 60 minuten laten inwerken en afspoelen met hete hogedruk. Op niet-poreuze ondergrond 5 tot 15 minuten laten inwerken en afwrijven.',
    tip: 'Laat de eerste laag ongeveer 2 uur drogen tot hij stofdroog is voordat je de tweede laag aanbrengt. Volledige bescherming na 72 uur.' };

  /* Problemen die in de titel staan: bepalen welke verwijderaar bij het artikel past */
  var PROBLEMS = [['graffiti', /graffiti/], ['cement', /cementsluier|cement sluier|cementresten/], ['kalk', /kalkuitbloei|uitbloei/]];
  /* Doel van het artikel, als het slimme blogsysteem niet op de pagina staat (zelfde regels als nce-blog.liquid) */
  var RX_BES = /\b(impregne|coaten\b|bescherm|waterafstot|waterdicht|vuilafstot|verzegel|behandel|sealen\b|sealer|waterbestendig|vuilwerend|hydrofoob|voorkom)|coating|impregn|bescherm/;
  var RX_REI = /\b(reinig|schoonma|wassen\b|poets|ontvet|opknap|verwijder|ontkalk|ontgrijz|schoonhouden\b|afbeitsen\b)|reinig|verwijder/;
  var RX_NOUN = /vlek|aanslag/;
  function purposeOf(txt) {
    txt = ' ' + String(txt || '').replace(/poedercoating/g, ' poeder ') + ' ';
    var bes = RX_BES.test(txt), rei = RX_REI.test(txt);
    if (!rei && !bes && RX_NOUN.test(txt)) rei = true;
    return bes && rei ? 'beide' : bes ? 'beschermen' : rei ? 'reinigen' : 'onbekend';
  }

  /* Onderwerp uit het slimme blogsysteem -> ondergrond */
  var TOPIC_MAP = { steen: 'steen', hout: 'hout', textiel: 'textiel', glas: 'glas', auto: 'auto', kunststof: 'kunststof', metaal: 'metaal' };
  /* Reserve als het slimme blogsysteem niet op de pagina staat */
  var FALLBACK_WORDS = [
    ['auto', /\b(auto|autolak|lakverzegel\w*|carrosserie|camper|caravan|motor)\b/],
    ['glas', /\b(glas|glazen|ramen|raam|ruit\w*|douchewand\w*|douchecabine\w*|spiegel\w*)\b/],
    ['hout', /\b(hout\w*|vlonder\w*|schutting\w*|teak|steigerhout|tuinmeubel\w*)\b/],
    ['textiel', /\b(textiel\w*|stof|stoffen|kleding|jas|jassen|bank|bankstel\w*|tapijt\w*|schoen\w*|sneaker\w*|leder\w*|leer|suede|suède|zonnescherm\w*|parasol\w*|kussen\w*)\b/],
    ['steen', /\b(steen|stenen|natuursteen\w*|beton\w*|tegel\w*|voeg\w*|terras\w*|oprit\w*|klinker\w*|bestrating|gevel\w*|marmer\w*|graniet\w*)\b/],
    ['kunststof', /\b(kunststof\w*|pvc|kozijn\w*)\b/],
    ['metaal', /\b(metaal|rvs|aluminium|chroom)\b/],
    ['muur', /\b(muurverf|binnenmuur\w*)\b/]
  ];

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isShop = !!(window.Shopify && window.Shopify.shop);
  var catalog = {};

  /* ------------------------------------------------------------------ */
  /* 3. Hulpjes                                                           */
  /* ------------------------------------------------------------------ */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }
  function fmtVol(m) { return m >= 1000 ? String(Math.round(m / 100) / 10).replace('.', ',') + ' liter' : m + ' ml'; }
  function fmtNum(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function need(area, layers, cov) { return Math.ceil(area * (layers || 1) / cov * 1000 * MARGIN); }
  function cleanTitle(t) { return String(t || '').replace(/<[^>]+>/g, ' ').replace(/➤/g, '').replace(/\s+/g, ' ').trim(); }
  function parseMl(title) {
    var m = String(title || '').toLowerCase().replace(/<[^>]+>/g, ' ').match(/(\d+(?:[.,]\d+)?)\s*(ml|liter|l)\b/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(',', '.'));
    return m[2] === 'ml' ? Math.round(n) : Math.round(n * 1000);
  }

  function fallback(key) {
    var p = PRODUCTS[key];
    return { key: key, handle: p.h, title: p.n, url: root + 'products/' + p.h, live: false,
      variants: p.v.map(function (x, i) { return { id: null, ml: x[0], price: x[1], available: true, position: i }; }) };
  }
  function load(key) {
    if (catalog[key]) return catalog[key];
    var p = PRODUCTS[key], fb = fallback(key);
    if (!isShop || !window.fetch) { catalog[key] = Promise.resolve(fb); return catalog[key]; }
    catalog[key] = fetch(root + 'products/' + p.h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var vs = (d.variants || []).map(function (v, i) {
          return { id: v.id, ml: parseMl(v.title || v.option1), price: v.price, available: v.available !== false, position: i };
        });
        return { key: key, handle: p.h, title: d.title || p.n, url: root + 'products/' + p.h, live: true, variants: vs };
      })
      .catch(function () { return fb; });
    return catalog[key];
  }

  /* Goedkoopste combinatie flesmaten die minstens `ml` oplevert (zelfde als keuzehulp). */
  function bestCombo(prod, ml) {
    var vs = prod.variants.filter(function (v) { return v.available && v.ml && v.price != null; });
    if (!vs.length) return null;
    var step = 100, units = vs.map(function (v) { return Math.max(1, Math.round(v.ml / step)); });
    var target = Math.max(1, Math.ceil(ml / step)), maxU = target + Math.max.apply(null, units);
    var cost = [0], bottles = [0], pick = [-1];
    for (var u = 1; u <= maxU; u++) {
      cost[u] = Infinity; bottles[u] = Infinity; pick[u] = -1;
      for (var i = 0; i < vs.length; i++) {
        var prev = Math.max(0, u - units[i]), c = cost[prev] + vs[i].price, b = bottles[prev] + 1;
        if (c < cost[u] || (c === cost[u] && b < bottles[u])) { cost[u] = c; bottles[u] = b; pick[u] = i; }
      }
    }
    var at = target, items = {}, total = 0, vol = 0;
    while (at > 0 && pick[at] > -1) {
      var v = vs[pick[at]];
      items[v.position] = (items[v.position] || 0) + 1; total += v.price; vol += v.ml;
      at = Math.max(0, at - units[pick[at]]);
    }
    var list = Object.keys(items).map(function (pos) {
      return { variant: vs.filter(function (x) { return String(x.position) === pos; })[0], qty: items[pos] };
    }).sort(function (x, y) { return y.variant.ml - x.variant.ml; });
    return { items: list, cost: total, ml: vol };
  }
  function smallest(prod) {
    var vs = prod.variants.filter(function (v) { return v.available && v.price != null; });
    if (!vs.length) return null;
    vs.sort(function (x, y) { return (x.ml || 0) - (y.ml || 0) || x.price - y.price; });
    return { items: [{ variant: vs[0], qty: 1 }], cost: vs[0].price, ml: vs[0].ml };
  }
  function oneLiter(prod) { return prod.variants.filter(function (v) { return v.available && v.ml === 1000; })[0] || null; }

  /* ------------------------------------------------------------------ */
  /* 4. Berekening                                                        */
  /* ------------------------------------------------------------------ */
  function pick(list, v) {
    if (!list) return null;
    return list.filter(function (k) { return k.v === v; })[0] || list.filter(function (k) { return k.def; })[0] || list[0];
  }
  /* state: { mat, kind, ckind, area, clean, coat, freeCart } */
  function calculate(state) {
    var mat = MATERIALS[state.mat];
    var wantCoat = !!(state.coat && mat.coat), wantClean = !!(state.clean && mat.clean);
    var kind = wantCoat ? pick(mat.kinds, state.kind) : null;
    if (kind && kind.mustClean) wantClean = true;
    var ckind = wantClean ? pick(mat.ckinds, state.ckind) : null;
    var res = { mat: mat, kind: kind, ckind: ckind, wantCoat: wantCoat, wantClean: wantClean, warns: [], stop: kind && kind.stop, area: 0, lines: [], notes: [], total: 0 };
    if (kind && kind.warn) res.warns.push(kind.warn);
    if (wantClean && mat.cwarn) res.warns.push(mat.cwarn);
    if (res.stop) return Promise.resolve(res);
    var area = kind && kind.m2 ? kind.m2 : Number(String(state.area).replace(',', '.'));
    if (!(area > 0)) return Promise.resolve(res);
    res.area = area;
    var coatP = wantCoat ? PRODUCTS[mat.coat] : null, cleanP = wantClean ? PRODUCTS[mat.clean] : null;
    var coatCov = coatP ? ((kind && kind.cov) || coatP.cov) : 0, layers = (kind && kind.layers) || 1;
    var cleanCov = cleanP ? ((ckind && ckind.ccov) || cleanP.cov) : 0;
    var coatNeed = coatP ? need(area, layers, coatCov) : 0;
    var cleanNeed = cleanP && !cleanP.fixed ? need(area, 1, cleanCov) : 0;

    var keys = []; if (coatP) keys.push(mat.coat); if (cleanP) keys.push(mat.clean);
    return Promise.all(keys.map(load)).then(function (prods) {
      var n = 0, coat = coatP ? prods[n++] : null, cleaner = cleanP ? prods[n++] : null;
      var coatC = coat ? bestCombo(coat, coatNeed) : null, cleanC = null, freeCents = 0;
      if (coatP && !coatC) return res;
      if (cleaner) cleanC = cleanP.fixed ? smallest(cleaner) : bestCombo(cleaner, cleanNeed);

      var free = coatP && coatP.free;
      if (free && cleaner && cleanC && free.clean === mat.clean) {
        /* Gratis liter reiniger vanaf een bepaalde hoeveelheid coating (zelfde reiniger als in dit plan) */
        var liter = oneLiter(cleaner);
        if (liter) {
          var withFree = function (cc) {
            var rest = Math.max(0, cleanNeed - 1000);
            var r = rest > 0 ? bestCombo(cleaner, rest) : { items: [], cost: 0, ml: 0 };
            var items = r.items.map(function (x) { return { variant: x.variant, qty: x.qty }; });
            var f = items.filter(function (x) { return x.variant.position === liter.position; })[0];
            if (f) f.qty += 1; else items.push({ variant: liter, qty: 1 });
            return { coat: cc, clean: { items: items, cost: r.cost + liter.price, ml: r.ml + 1000 }, free: liter.price };
          };
          var plain = coatC.cost + cleanC.cost;
          if (coatC.ml >= free.min) {
            var w = withFree(coatC); cleanC = w.clean; freeCents = w.free;
          } else {
            var up = bestCombo(coat, free.min);
            if (up) {
              var w2 = withFree(up), upTotal = w2.coat.cost + w2.clean.cost - w2.free;
              if (upTotal <= plain) {
                coatC = up; cleanC = w2.clean; freeCents = w2.free;
                res.notes.push('Met ' + fmtVol(up.ml) + ' coating krijg je 1 liter reiniger gratis. Zo ben je ' + money(plain - upTotal) + ' voordeliger uit.');
              } else if (upTotal - plain <= 1500) {
                res.notes.push('Tip: voor ' + money(upTotal - plain) + ' meer neem je ' + fmtVol(free.min) + ' coating en krijg je 1 liter reiniger gratis.');
              }
            }
          }
        }
      } else if (free && coatC && coatC.ml >= free.min && state.freeCart !== false) {
        /* De gratis reiniger hoort bij een ander product dan in dit plan: de winkelwagen voegt hem zelf toe */
        res.notes.push('Bij deze hoeveelheid coating krijg je in de winkelwagen 1 liter ' + PRODUCTS[free.clean].n + ' gratis.');
      }
      if (cleanC) res.lines.push({ key: 'clean', role: coatC ? 'Stap 1 · Reinigen' : 'Reinigen', prod: cleaner, combo: cleanC, need: cleanP.fixed ? 0 : cleanNeed, cov: cleanCov, range: cleanP.range, free: freeCents, layers: 1 });
      if (coatC) res.lines.push({ key: 'coat', role: cleanC ? 'Stap 2 · Beschermen' : 'Beschermen', prod: coat, combo: coatC, need: coatNeed, cov: coatCov, range: coatP.range, free: 0, layers: layers });
      if (!res.lines.length) return res;
      res.total = res.lines.reduce(function (s, l) { return s + l.combo.cost - l.free; }, 0);
      res.canCart = res.lines.every(function (l) { return l.combo.items.every(function (it) { return it.variant.id; }); });
      return res;
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Weergave                                                          */
  /* ------------------------------------------------------------------ */
  function defaultsFor(mode, cleanDefault) {
    if (mode === 'reinigen') return { clean: true, coat: false };
    if (mode === 'beschermen') return { clean: cleanDefault, coat: true };
    return { clean: true, coat: true };
  }
  function Calc(el, cfg) {
    this.el = el;
    this.d = el.dataset;
    this.uid = 'ncc' + Math.random().toString(36).slice(2, 8);
    this.mode = cfg.mode;
    var df = defaultsFor(this.mode, this.d.clean !== 'false');
    this.state = { mat: MATERIALS[cfg.scen] ? cfg.scen : 'steen', kind: '', ckind: '', area: '', clean: df.clean, coat: df.coat, freeCart: this.d.free !== 'zelf' };
    this.first = this.state.mat;
    this.tracked = false;
    this.render();
  }
  Calc.prototype.scenarios = function () {
    var mode = this.mode, first = this.first;
    return Object.keys(MATERIALS).filter(function (k) {
      var m = MATERIALS[k];
      if (mode === 'reinigen' && !m.cleanOk) return false;
      if (m.problem && mode === 'beschermen' && k !== first && k !== 'graffiti') return false;
      return true;
    });
  };
  Calc.prototype.plan = function () {
    var m = MATERIALS[this.state.mat], s = this.state;
    var coat = !!(s.coat && m.coat), clean = !!(s.clean && m.clean);
    var kind = coat && m.kinds ? pick(m.kinds, s.kind) : null;
    if (kind && kind.mustClean) clean = true;
    return { m: m, coat: coat, clean: clean, kind: kind };
  };
  function chipsHtml(list, name, sel, q) {
    return '<fieldset class="nce-calc__field"><legend class="nce-calc__label">' + esc(q) + '</legend><div class="nce-calc__chips">' +
      list.map(function (k) {
        return '<label class="nce-calc__chip"><input type="radio" name="' + name + '" value="' + k.v + '"' + (k.v === sel ? ' checked' : '') + '>' +
          '<span><strong>' + esc(k.l) + '</strong>' + (k.h ? '<small>' + esc(k.h) + '</small>' : '') + '</span></label>';
      }).join('') + '</div></fieldset>';
  }
  Calc.prototype.kindsHtml = function () {
    var p = this.plan(), s = this.state;
    if (!p.coat || !p.m.kinds) return '';
    s.kind = pick(p.m.kinds, s.kind).v;
    return chipsHtml(p.m.kinds, this.uid + '-kind', s.kind, p.m.kq);
  };
  Calc.prototype.ckindsHtml = function () {
    var p = this.plan(), s = this.state;
    if (!p.clean || !p.m.ckinds) return '';
    s.ckind = pick(p.m.ckinds, s.ckind).v;
    return chipsHtml(p.m.ckinds, this.uid + '-ckind', s.ckind, p.m.ckq);
  };
  Calc.prototype.areaHtml = function () {
    var p = this.plan(), s = this.state, u = this.uid, m = p.m;
    if (p.kind && (p.kind.m2 || p.kind.stop)) return '';
    return '<div class="nce-calc__field"><label class="nce-calc__label" for="' + u + '-area">Hoeveel m² wil je behandelen?</label>' +
      '<div class="nce-calc__area"><input id="' + u + '-area" class="nce-calc__input" type="number" inputmode="decimal" min="0.1" step="0.1" placeholder="0" value="' + esc(s.area) + '"><span>m²</span></div>' +
      (m.presets ? '<div class="nce-calc__presets">' + m.presets.map(function (pr) {
        return '<button type="button" class="nce-calc__preset" data-m2="' + pr[1] + '">' + esc(pr[0]) + ' <small>' + fmtNum(pr[1]) + ' m²</small></button>';
      }).join('') + '</div>' : '') +
      '<details class="nce-calc__lb"><summary>Uitrekenen: lengte × breedte</summary><div class="nce-calc__lbrow">' +
      '<input type="number" inputmode="decimal" min="0" step="0.1" placeholder="Lengte (m)" aria-label="Lengte in meter" data-lb="l"> <span>×</span> ' +
      '<input type="number" inputmode="decimal" min="0" step="0.1" placeholder="Breedte (m)" aria-label="Breedte in meter" data-lb="b"></div></details></div>';
  };
  /* Keuzevakjes: het hoofdproduct van het artikel staat vast, het andere product is een optionele aanvulling */
  Calc.prototype.checksHtml = function () {
    var s = this.state, m = MATERIALS[s.mat], mode = this.mode, p = this.plan();
    var cleanLocked = mode === 'reinigen' || (mode === 'beide' && p.coat === false) || (p.kind && p.kind.mustClean);
    var coatLocked = mode === 'beschermen' || (mode === 'beide' && !s.clean);
    var h = '';
    var cn = PRODUCTS[m.clean].n, tn = PRODUCTS[m.coat].n;
    var lock = function (b) { return b ? ' checked disabled' : ''; };
    var cleanLabel = mode === 'reinigen' ? 'Reinigen met ' + esc(cn) : 'Eerst reinigen met ' + esc(cn) + ' <small>(' + (mode === 'beide' ? 'bij dit artikel' : 'aanbevolen') + ')</small>';
    var coatLabel = mode === 'beschermen' ? 'Beschermen met ' + esc(tn) : (mode === 'reinigen' ? 'Daarna beschermen met ' + esc(tn) + ' <small>(optioneel' + (m.coatNote ? '. ' + esc(m.coatNote) : '') + ')</small>' : 'Beschermen met ' + esc(tn));
    h += '<label class="nce-calc__check' + (cleanLocked ? ' is-locked' : '') + '"><input type="checkbox" data-k="clean"' + (cleanLocked ? ' checked disabled' : (s.clean ? ' checked' : '')) + '> <span>' + cleanLabel + '</span></label>';
    h += '<label class="nce-calc__check' + (coatLocked ? ' is-locked' : '') + '"><input type="checkbox" data-k="coat"' + (coatLocked ? ' checked disabled' : (s.coat ? ' checked' : '')) + '> <span>' + coatLabel + '</span></label>';
    return h;
  };
  Calc.prototype.render = function () {
    var s = this.state, u = this.uid, d = this.d, mode = this.mode;
    var opts = this.scenarios().map(function (k) { return '<option value="' + k + '"' + (k === s.mat ? ' selected' : '') + '>' + esc(MATERIALS[k].label) + '</option>'; }).join('');
    var html = '<p class="nce-calc__title">' + esc(d.title || 'Bereken hoeveel je nodig hebt') + '</p>' +
      '<p class="nce-calc__intro">' + esc(d.intro || 'Vul je oppervlakte in en zie direct hoeveel product je nodig hebt en wat het kost.') + '</p>' +
      '<div class="nce-calc__form">' +
      '<div class="nce-calc__field"><label class="nce-calc__label" for="' + u + '-mat">' + (mode === 'reinigen' ? 'Wat wil je schoonmaken of verwijderen?' : 'Wat wil je behandelen?') + '</label>' +
      '<select id="' + u + '-mat" class="nce-calc__select" data-k="mat">' + opts + '</select></div>' +
      '<div data-part="ckinds">' + this.ckindsHtml() + '</div>' +
      '<div data-part="kinds">' + this.kindsHtml() + '</div>' +
      '<div data-part="area">' + this.areaHtml() + '</div>' +
      '<div class="nce-calc__checks" data-part="checks">' + this.checksHtml() + '</div>' +
      '</div><div class="nce-calc__result" data-part="result" aria-live="polite"></div>';
    this.el.innerHTML = html;
    if (!this.bound) { this.bind(); this.bound = true; }
    this.update();
  };
  Calc.prototype.part = function (n) { return this.el.querySelector('[data-part="' + n + '"]'); };
  Calc.prototype.refreshParts = function () {
    this.part('ckinds').innerHTML = this.ckindsHtml();
    this.part('kinds').innerHTML = this.kindsHtml();
    this.part('area').innerHTML = this.areaHtml();
    this.part('checks').innerHTML = this.checksHtml();
    this.markPreset();
  };
  Calc.prototype.bind = function () {
    var self = this, el = this.el;
    el.addEventListener('change', function (e) {
      var t = e.target, k = t.getAttribute('data-k');
      if (k === 'mat') {
        var df = defaultsFor(self.mode, self.d.clean !== 'false');
        self.state.mat = t.value; self.state.kind = ''; self.state.ckind = ''; self.state.clean = df.clean; self.state.coat = df.coat;
        self.refreshParts(); self.update(); return;
      }
      if (k === 'clean' || k === 'coat') { self.state[k] = t.checked; self.refreshParts(); self.update(); return; }
      if (t.type === 'radio') {
        if (/-ckind$/.test(t.name)) self.state.ckind = t.value; else self.state.kind = t.value;
        self.part('area').innerHTML = self.areaHtml(); self.markPreset(); self.update();
      }
    });
    el.addEventListener('input', function (e) {
      var t = e.target;
      if (t.classList.contains('nce-calc__input')) { self.state.area = t.value; self.markPreset(); self.update(); }
      if (t.hasAttribute('data-lb')) {
        var l = parseFloat((el.querySelector('[data-lb="l"]').value || '').replace(',', '.')), b = parseFloat((el.querySelector('[data-lb="b"]').value || '').replace(',', '.'));
        if (l > 0 && b > 0) { var a = Math.round(l * b * 10) / 10; self.state.area = String(a); var inp = el.querySelector('.nce-calc__input'); if (inp) inp.value = a; self.markPreset(); self.update(); }
      }
    });
    el.addEventListener('click', function (e) {
      var p = e.target.closest && e.target.closest('.nce-calc__preset');
      if (p) { self.state.area = p.getAttribute('data-m2'); var inp = el.querySelector('.nce-calc__input'); if (inp) inp.value = self.state.area; self.markPreset(); self.update(); return; }
      var c = e.target.closest && e.target.closest('[data-act="cart"]');
      if (c) { self.addToCart(c); return; }
      var k = e.target.closest && e.target.closest('[data-act="keuzehulp"]');
      if (k) self.track('blog_calculator_choiceguide_click', {});
    });
  };
  Calc.prototype.markPreset = function () {
    var a = this.state.area;
    Array.prototype.forEach.call(this.el.querySelectorAll('.nce-calc__preset'), function (b) { b.classList.toggle('is-on', String(b.getAttribute('data-m2')) === String(a)); });
  };
  Calc.prototype.update = function () {
    var self = this, box = this.el.querySelector('[data-part="result"]');
    var token = (this._t = (this._t || 0) + 1);
    calculate(this.state).then(function (r) {
      if (token !== self._t) return;
      self.result = r;
      box.innerHTML = self.resultHtml(r);
      if (r.lines.length && !self.tracked) { self.tracked = true; self.track('blog_calculator_use', { calc_material: self.state.mat, calc_mode: self.mode, calc_area: r.area }); }
    });
  };
  Calc.prototype.resultHtml = function (r) {
    var d = this.d, h = '';
    if (r.stop) return '<div class="nce-calc__note nce-calc__note--warn">' + esc(r.stop) + '</div>' + this.footHtml();
    if (!r.lines.length) {
      return (r.warns.length ? r.warns.map(function (w) { return '<div class="nce-calc__note nce-calc__note--warn">' + esc(w) + '</div>'; }).join('') : '') +
        '<p class="nce-calc__empty">Vul het aantal m² in om je hoeveelheid en prijs te zien.</p>';
    }
    h += '<p class="nce-calc__sum">Voor <strong>' + fmtNum(r.area) + ' m²</strong>' + (r.kind && r.kind.m2 ? ' lak' : '') + ' heb je nodig:</p><ul class="nce-calc__lines">';
    r.lines.forEach(function (l) {
      var bottles = l.combo.items.map(function (it) { return it.qty + '× ' + (it.variant.ml ? fmtVol(it.variant.ml) : 'fles'); }).join(' + ');
      h += '<li class="nce-calc__line"><div class="nce-calc__lmain"><span class="nce-calc__role">' + esc(l.role) + '</span>' +
        '<a class="nce-calc__pname" href="' + esc(l.prod.url) + '" data-act="product">' + esc(cleanTitle(l.prod.title)) + '</a>' +
        '<span class="nce-calc__bottles">' + (l.need ? 'Nodig: ± ' + fmtVol(l.need) + (l.layers > 1 ? ' (' + l.layers + ' lagen)' : '') + ' · ' : '') + 'Advies: ' + esc(bottles) + '</span>' +
        (l.free ? '<span class="nce-calc__free">1 liter gratis bij deze hoeveelheid coating</span>' : '') +
        '</div>' + (d.prices !== 'false' ? '<div class="nce-calc__price">' + (l.free ? '<s>' + money(l.combo.cost) + '</s>' : '') + '<strong>' + money(l.combo.cost - l.free) + '</strong></div>' : '') + '</li>';
    });
    h += '</ul>';
    r.notes.forEach(function (n) { h += '<div class="nce-calc__note nce-calc__note--good">' + esc(n) + '</div>'; });
    r.warns.forEach(function (w) { h += '<div class="nce-calc__note nce-calc__note--warn">' + esc(w) + '</div>'; });
    if (d.prices !== 'false') h += '<div class="nce-calc__total"><span>Totaal</span><strong>' + money(r.total) + '</strong></div>';
    if (d.cart !== 'false') {
      h += r.canCart
        ? '<button type="button" class="nce-calc__btn" data-act="cart">In winkelwagen</button><p class="nce-calc__msg" role="status"></p>'
        : '<a class="nce-calc__btn" href="' + esc(r.lines[r.lines.length - 1].prod.url) + '">Bekijk het product</a>';
    }
    var calcd = r.lines.map(function (l) { return fmtNum(l.cov) + ' m² per liter' + (l.layers > 1 ? ' per laag' : '') + (r.lines.length > 1 ? ' voor de ' + (l.key === 'clean' ? 'reiniger' : 'coating') : ''); }).join(' en ');
    var ranges = r.lines.filter(function (l) { return l.range; }).map(function (l) { return 'Volgens de productpagina is het verbruik van ' + cleanTitle(l.prod.title) + ' ' + l.range + '.'; }).join(' ');
    var tips = [r.wantClean && r.mat.ctip, r.wantCoat && r.mat.tip].filter(Boolean).map(esc).join(' ');
    h += '<p class="nce-calc__fine">Berekend met ' + calcd + ', inclusief 10% marge. Het werkelijke verbruik hangt af van de ondergrond en de vervuiling. ' + esc(ranges) + ' ' + tips +
      (r.lines.some(function (l) { return l.free; }) ? (this.state.freeCart !== false ? ' De gratis liter reiniger voegt de winkelwagen automatisch toe.' : ' De gratis liter wordt in de winkelwagen verrekend.') : '') + '</p>';
    return h + this.footHtml();
  };
  Calc.prototype.footHtml = function () {
    if (!this.d.keuzehulp) return '';
    return '<p class="nce-calc__alt">Twijfel je over je ondergrond? <a href="' + esc(this.d.keuzehulp) + '" data-act="keuzehulp">Doe de keuzehulp voor persoonlijk advies →</a></p>';
  };
  /* Producten voor de winkelwagen. Met "gratis liter via de winkelwagen" laat de calculator die ene liter weg: de winkelwagen voegt hem zelf toe. */
  Calc.prototype.cartItems = function (r) {
    var viaCart = this.state.freeCart !== false, items = [];
    r.lines.forEach(function (l) {
      var skip = viaCart && l.free > 0;
      l.combo.items.forEach(function (it) {
        var q = it.qty;
        if (skip && it.variant.ml === 1000) { q -= 1; skip = false; }
        if (q > 0) items.push({ id: it.variant.id, quantity: q });
      });
    });
    return items;
  };
  Calc.prototype.addToCart = function (btn) {
    var r = this.result, self = this, msg = this.el.querySelector('.nce-calc__msg');
    if (!r || !r.canCart) return;
    var items = this.cartItems(r);
    if (!items.length) return;
    btn.disabled = true; btn.textContent = 'Bezig met toevoegen…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Toevoegen mislukt'); return j; }); })
      .then(function () {
        self.track('blog_calculator_add_to_cart', { calc_material: self.state.mat, calc_mode: self.mode, calc_area: r.area, value: r.total / 100, currency: 'EUR' });
        window.location.href = root + 'cart';
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = 'In winkelwagen';
        if (msg) msg.textContent = 'Toevoegen lukte niet: ' + err.message + '. Probeer het opnieuw of bestel via de productpagina.';
      });
  };
  Calc.prototype.track = function (ev, data) {
    if (this.d.tracking !== 'true') return;
    window.dataLayer = window.dataLayer || [];
    data.event = ev; data.article_url = location.pathname;
    window.dataLayer.push(data);
  };

  /* ------------------------------------------------------------------ */
  /* 6. Doel en onderwerp bepalen, en plaatsen in het artikel              */
  /* ------------------------------------------------------------------ */
  function articleText(el) { return (el.dataset.articleTitle + ' ' + el.dataset.articleHandle).toLowerCase().replace(/[-_]/g, ' '); }
  function detectMaterial(el) {
    var nce = document.querySelector('[data-nce-root]');
    var t = nce && nce.dataset.topic;
    if (t && TOPIC_MAP[t]) return TOPIC_MAP[t];
    if (t && t !== 'algemeen') return ''; // bv. vlekken: geen calculator-onderwerp
    var txt = (el.dataset.articleTitle + ' ' + el.dataset.articleHandle + ' ' + el.dataset.articleTags).toLowerCase().replace(/[-_]/g, ' ');
    for (var i = 0; i < FALLBACK_WORDS.length; i++) if (FALLBACK_WORDS[i][1].test(txt)) return FALLBACK_WORDS[i][0];
    return '';
  }
  /* Geeft { mode, scen } of null (dan verschijnt er geen calculator) */
  function detect(el) {
    var nce = document.querySelector('[data-nce-root]');
    var purpose = (nce && nce.dataset.purpose) || purposeOf(articleText(el));
    var txt = articleText(el), scen = '';
    for (var i = 0; i < PROBLEMS.length; i++) if (PROBLEMS[i][1].test(txt)) { scen = PROBLEMS[i][0]; break; }
    if (!scen) scen = detectMaterial(el);
    var mode = purpose === 'beschermen' ? 'beschermen' : purpose === 'reinigen' ? 'reinigen' : 'beide';
    if (!scen) return el.dataset.show === 'alle' ? { mode: 'beide', scen: 'steen' } : null;
    if (purpose === 'onbekend') return el.dataset.show === 'alle' ? { mode: 'beide', scen: scen } : null;
    if (mode === 'reinigen' && !MATERIALS[scen].cleanOk) return el.dataset.show === 'alle' ? { mode: 'beide', scen: scen } : null;
    return { mode: mode, scen: scen };
  }
  function content(sel) {
    var list = (sel || '').split(',').concat(['.article-template__content', '.article__content', '.article-content', '[itemprop="articleBody"]']);
    for (var i = 0; i < list.length; i++) {
      var s = list[i].trim(); if (!s) continue;
      var c; try { c = document.querySelector(s); } catch (e) { c = null; }
      if (c && c.querySelector('h2, p')) return c;
    }
    return null;
  }
  var RX_HOW = /hoeveel|verbruik|benodigd|stappenplan|werkwijze|zo ga je|aan de slag|aanbrengen|zelf (impregneren|coaten|behandelen)/i;
  var RX_FAQ = /veelgestelde|faq|vragen/i;
  function place(el) {
    if (el.dataset.position === 'onder') return;
    var c = content(el.dataset.selector);
    if (!c || c.contains(el)) return;
    var hs = Array.prototype.filter.call(c.querySelectorAll('h2'), function (h) { return !h.closest('.nce-blog-toc, .nce-blog-inline, .nce-calc'); });
    var target = null, i;
    for (i = 1; i < hs.length; i++) if (RX_HOW.test(hs[i].textContent) && !RX_FAQ.test(hs[i].textContent)) { target = hs[i]; break; }
    if (!target) {
      var panel = c.querySelector('[data-nce-panel]');
      if (panel) { panel.parentNode.insertBefore(el, panel); return finish(el); }
    }
    if (!target && hs.length >= 2) {
      var mid = Math.ceil(hs.length / 2);
      for (i = mid; i < hs.length; i++) if (!RX_FAQ.test(hs[i].textContent)) { target = hs[i]; break; }
    }
    if (target) target.parentNode.insertBefore(el, target); else c.appendChild(el);
    finish(el);
  }
  function finish(el) { el.classList.add('nce-calc--inline'); }

  function init(el) {
    if (el.__ncc) return; el.__ncc = true;
    var cfg = detect(el);
    if (!cfg) { el.remove(); return; }
    el.dataset.material = cfg.scen; el.dataset.mode = cfg.mode;
    place(el);
    el.hidden = false;
    new Calc(el, cfg);
  }
  function boot() { setTimeout(function () { Array.prototype.forEach.call(document.querySelectorAll('[data-nce-calc]'), init); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.NCECalc = { calculate: calculate, MATERIALS: MATERIALS, PRODUCTS: PRODUCTS, bestCombo: bestCombo, purposeOf: purposeOf, detectProblem: function (t) { for (var i = 0; i < PROBLEMS.length; i++) if (PROBLEMS[i][1].test(t)) return PROBLEMS[i][0]; return ''; } };
})();
